/**
 * FIRST-MOVERS-ANCHOR-NAVIGATION
 * ----------------------------------------------------------------------------------------------
 * Sitewide, generische Anchor-Navigation für jeden Link, dessen Ziel wirklich "/#first-movers-form"
 * oder "#first-movers-form" ist (Desktop-/Mobile-Hauptnavigation "First Movers", Mobile-Drawer
 * PROLETHIC-Club-CTA, künftige CTA-Buttons auf Produkt-/Collection-/Content-Seiten, ...). Es sind
 * hier bewusst KEINE einzelnen Buttons hart codiert - jeder Link mit diesem Ziel funktioniert
 * automatisch, egal wo im Theme-Editor er gesetzt wird.
 *
 * Verhalten:
 * - Das Ziel-Element #first-movers-form existiert bereits auf der aktuellen Seite: kein Reload,
 *   smooth dorthin scrollen (nutzt die vorhandene "scroll-padding-block-start" aus
 *   assets/theme.css für den Sticky-Header-Abstand, dieselbe Logik gilt für jeden Anchor-Sprung
 *   im Theme, nicht nur diesen). Bewusst KEIN Seiten-/Template-Check (z. B. "ist das die
 *   Startseite") - stattdessen wird direkt geprüft, ob das Element wirklich da ist. Das bleibt
 *   auch dann korrekt, wenn sich z. B. während der Pre-Launch-Phase ändert, auf welcher
 *   Seite/Template das Formular liegt.
 * - Element ist auf der aktuellen Seite nicht vorhanden: normal zu "/#first-movers-form"
 *   navigieren (kein Eingriff nötig). Nach dem Laden der Zielseite wird der Sprung zusätzlich
 *   aktiv nachgeholt, damit er auch bei spät ladenden Bildern/Sections zuverlässig an der
 *   richtigen Stelle landet.
 * - Klick innerhalb des offenen mobilen Navigation-Drawers: Drawer zuerst über seine vorhandene
 *   Theme-Methode ".hide()" schließen (inkl. Warten auf deren Schließ-Animation/-Promise), erst
 *   danach scrollen - damit die Seite nie im Hintergrund hinter dem noch offenen Drawer scrollt.
 *
 * Betrifft ausschließlich Links mit diesem einen Ziel. Alle anderen Anchor-Links, Navigation,
 * Formularlogik und Styling bleiben komplett unangetastet.
 */
(function () {
  var TARGET_HASH = '#first-movers-form';
  var TARGET_ID = 'first-movers-form';

  function resolvesToTarget(href) {
    if (!href) {
      return false;
    }

    var url;

    try {
      url = new URL(href, window.location.origin);
    } catch (error) {
      return false;
    }

    // Deckt sowohl "/#first-movers-form" als auch das kürzere "#first-movers-form" ab - beides
    // löst relativ zu window.location.origin auf denselben Pfad "/" auf. Alles mit einem
    // abweichenden Pfad (z. B. "/some-page#first-movers-form") wird bewusst NICHT erfasst.
    return url.hash === TARGET_HASH && url.pathname === '/';
  }

  function getTarget() {
    return document.getElementById(TARGET_ID);
  }

  function scrollToTarget(target) {
    (target || getTarget())?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function updateUrlHash() {
    if (window.location.hash !== TARGET_HASH) {
      history.pushState(null, '', TARGET_HASH);
    }
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href]');

    if (!link || !resolvesToTarget(link.getAttribute('href'))) {
      return;
    }

    var target = getTarget();

    if (!target) {
      // Element ist auf dieser Seite (noch) nicht vorhanden: normal navigieren lassen, kein
      // Eingriff nötig - siehe scrollOnLoadIfNeeded für den Sprung nach dem Laden der Zielseite.
      return;
    }

    // Element ist schon da: kein Reload, sondern smooth scrollen.
    event.preventDefault();

    var drawer = link.closest('navigation-drawer, x-drawer');

    if (drawer && drawer.open && typeof drawer.hide === 'function') {
      // Vorhandene Theme-Drawer-Schließmethode nutzen (löst u. a. "dialog:after-hide" aus und
      // hebt die Scroll-Sperre des Drawers auf). Erst NACH Abschluss der Schließ-Animation
      // scrollen, sonst würde die Seite unter dem noch offenen/gesperrten Drawer scrollen.
      drawer.hide().then(function () {
        updateUrlHash();
        scrollToTarget(target);
      });
    } else {
      updateUrlHash();
      scrollToTarget(target);
    }
  });

  function scrollOnLoadIfNeeded() {
    if (window.location.hash !== TARGET_HASH) {
      return;
    }

    var target = getTarget();

    if (!target) {
      return;
    }

    // Der Browser springt beim Laden meist schon selbst zum Anker; falls sich die Position durch
    // spät ladende Bilder/Sections noch verschiebt, holen wir den (smooth-)Sprung hier einmal
    // zuverlässig nach, sobald wirklich alles geladen ist.
    requestAnimationFrame(function () {
      scrollToTarget(target);
    });
  }

  if (document.readyState === 'complete') {
    scrollOnLoadIfNeeded();
  } else {
    window.addEventListener('load', scrollOnLoadIfNeeded);
  }
})();
